import React, {Component} from 'react';
import { getTournamentFinances, createRegistrationStatus, isValid, reviseTUser, stopTimer, putToast, loadRegistration, AuthenticatedUser, processPayment } from "../../api"
import DropIn from 'braintree-web-drop-in-react';
//import { PayPalButton } from "react-paypal-button-v2";

import Modal from 'react-responsive-modal';
import InputRow from '../../pages/pageParts/inputForms/inputRow';
import InputItem from '../../pages/pageParts/inputForms/inputItem';
import InputCheckbox from '../../pages/pageParts/inputForms/inputCheckbox';
import {Link } from 'react-router-dom'
import EventRegistrationCube from './cubes/eventRegistrationCube';
import TournamentPageTemplate from './tournamentPageTemplate'
import ModalWindow from "../../common/modalWindow"
import PageCloser from '../../common/pageCloser'

//const PPDEV = process.env.REACT_APP_PPDEV;
//const PPPRD = process.env.REACT_APP_PPPRD;

class EventRegistration extends Component {
    btInstance;

    constructor(props) {
        super(props);
        const { match: { params } } = this.props;
        this.original = null;
        this.changed = null;
        const { user } = AuthenticatedUser();
        this.onCloseEventRegistrationModal = this.onCloseEventRegistrationModal.bind(this);
        this.onEventCompetitorDataChange = this.onEventCompetitorDataChange.bind(this);
        this.buy = this.buy.bind(this);
        this.onProfileNoticeCancel = this.onProfileNoticeCancel.bind(this);
        this.onProfileNotice = this.onProfileNotice.bind(this);

        this.state = {
            loading: true,
            open: false,
            openProfileNotice: false,
            user: user,
            pid: params.pid,
            tagged: [],
            tData: {},
            tEventCompetitor: {},
            tEvent: {},
            clientToken: null,
            transaction: null,
            judgeListConfirmed: false,
            tUser: {},
            tUserEvent: {}
        }

    }

    loadTournamentPage = (pid) => {       
        if (this.state.pid) {
            loadRegistration(this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    const tUser = d2.tUser ? d2.tUser : {
                        tournamentId: d2.tournamentPage._id,
                        userId: this.state.user._id,
                    }  
                    
                    /*
                    getBraintreeClientToken().then(d3 => {
                        if (d3.error) {
                            console.log(d3.error);
                            this.setState({tData: d2.tournamentPage, tUser: tUser,  loading: false});                    
                        } else {*/
                            this.setState({tData: d2.tournamentPage, tUser: tUser, clientToken: 'badfood', loading: false});                    
                        /*}
                    });
                    */
                }
            });
        } else this.setState({ loading: false});
    };

    async buy() {
        const { tData, tUser } = this.state;
        const fee = tUser.events.filter(x=>x.isRegistered && !x.isPaid).reduce((a,b) => a + (b.fee || 0), 0);
        if (fee > 0 && this.btInstance) {
            const { nonce } = await this.btInstance.requestPaymentMethod();
            const paymentData = {
                paymentMethodNonce: nonce,
                cart: {
                    cartItems: [{
                        product: {
                            _id: 0,
                            title: `${tData.title} fee`,
                            myPrice: fee,
                            receivedTags: '',
                            resources: [],
                        },
                        quantity: 1
                    }],
                    cartTotals: {
                        discounts: 0,
                        shipping: 0,
                        subtotal: 0,
                        total: fee
                    }
                    
                },                        
            };
            processPayment(paymentData)
            .then(response => {
                
                for(const event of tUser.events.filter(x=>x.isRegistered)) {
                    event.isPaid = true;
                }

                reviseTUser(tUser).then(d2 => {
                    if (!d2 || d2.error) {
                        console.log(d2 ? d2.error : "Error - no data");
                        putToast.error(d2 ? d2.error : "Error - no data");
                    } else {
                        putToast.success(d2.message);
                        putToast.success("Payment Received.  Thank-you!")
                        this.setState({ tUser: d2.tUser, transaction: response.transaction }); 
                    }
                }); 
            })
            .catch(error => {
                console.log(error);
                //that.setState({ loading: false });
            });
        }
    }

    componentDidMount(){
        this.loadTournamentPage();        
    }

    onItemRegistration = (tEvent) => {
        const {tUser} = this.state;
        if (!tUser.events) tUser.events = [];
        var tUserEvent = tUser.events.find(x=>x.eventId === tEvent._id)
        if (!tUserEvent) {
            tUserEvent = {
                eventId: tEvent._id,
                isRegistered: false,
                isPaid: false,
                isPartnered: false,
            }
            tUser.events.push(tUserEvent);
        }
        this.original = JSON.parse(JSON.stringify(tUserEvent));

        if (tEvent.teamSize > 1) 
            this.setState({tEvent: tEvent, tUser: tUser, tUserEvent: tUserEvent, openMode: 'team', openEventTitle: tEvent.title, open: true})
        else
            this.setState({tEvent: tEvent, tUser: tUser, tUserEvent: tUserEvent, openMode: 'individual', openEventTitle: tEvent.title, open: true})
    };

    onCancelEventRegistrationModal = () => {
        const {tUser, tEvent} = this.state;
        
        const index = tUser.events.findIndex(x=>x.eventId === tEvent._id)
        tUser.events[index] = JSON.parse(JSON.stringify(this.original))

        this.setState({ tUser: tUser, tUserEvent: tUser.events[index],  open: false });    
    }

    onCloseEventRegistrationModal = () => {
        const {tUser, tUserEvent, tEvent } = this.state;
        //const fee = tUser.events.filter(x=>x.isRegistered && !x.isPaid).reduce((a, b) => a + (b.fee || 0), 0);

        // change the  - this should already have been set by the data change
        // tUserEvent.isRegistered = isRegistered;
        
        // see if we have any registrations on events, if so set the tuser
        tUser.isRegistered = false; 
        for(const event of tUser.events) {
            if (event.isRegistered) tUser.isRegistered = true;                      
        }
        tUserEvent.mode = tEvent.mode;
        tUserEvent.fee = tEvent.fee;
        tUserEvent.isPaid = tEvent.fee === 0;
        if (tUserEvent.partnerEmail) tUserEvent.partnerEmail = tUserEvent.partnerEmail.toLowerCase().trim();

        // if this is a single person team event, we don't need a partner so satisfied
        if (tEvent.teamSize === 1) tUserEvent.isPartnered = true;

        // once a person registers, they cannot become a judge
        reviseTUser(tUser).then(d2 => {
            if (!d2 || d2.error) {
                console.log(d2 ? d2.error : "Error - no data");
                putToast.error(d2 ? d2.error : "Error - no data");
            } else {
                putToast.success("Registered!");
                this.setState({ tUser, open: false})        
            }
        }); 
    }

    onProfileNotice() {
        this.setState({openProfileNotice: true })
    }

    onProfileNoticeCancel() {
        this.setState({openProfileNotice: false})
    }

    getApprovable(state) {
        var approvable = true;
        if (state) {
            approvable &= !state.tUserEvent.isPaid
            approvable &= isValid(state.tUserEvent.experience)
            //approvable &= (state.tEvent.teamSize === 1 || (state.tEvent.teamSize > 1 && isValidEmail(state.tUserEvent.partnerEmail)) )
            approvable |= !state.tUserEvent.isRegistered            
        }

        return approvable;
    }

    onEventCompetitorDataChange(evt) {
        const {tEvent} = this.state;

        const id = evt.target.id
        const val = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value

        let state = this.state;
        
        if (id === 'isRegistered' && tEvent.teamSize === 1) {
            state.tUserEvent.isPartnered = val;
        }

        state.tUserEvent[id] = val;

        this.setState(state);
    }

    displayCurrency (value) {
        if (!value) value = 0;
        return (
            <span style={{textAlign: 'right', fontfamily: 'monospace'}}>
                {true && <>${value.toFixed(2)}</>}
            </span>
        )
    }

    feeTitle(owes) {

        return (<>
            Balance: &nbsp;
            {this.displayCurrency(owes)}&nbsp;
        </>)
    }
    
    notice() {

        return (<>
            We're sorry, but you cannot register for this event until you have completed your Competitor Profile on your account.  If you wish to do this now, please click 
            &nbsp;<Link to='/pages/dashboard'>here</Link>.&nbsp;
        </>)
    }

    render () {
        if (this.state.loading) { return null; }

        stopTimer();
        const {tData, tEvent, open, tUser, tUserEvent, openEventTitle, user, transaction, clientToken } = this.state;
        const finances = getTournamentFinances(tUser);            
        var simRegistered = false;
        var maxRegistered = false;
        var allMaxRegistered = false;
        var tEventMax = false;

        if (open) {
            // we are registering, so check simGroups
            const simEvents = tData.events.filter(x=>x.simKey === tEvent.simKey).map(x=>x._id);
            const regSimEvents = tUser.events.filter(x=>x.isRegistered && x.eventId !== tUserEvent.eventId && simEvents.includes(x.eventId));
            simRegistered = regSimEvents && regSimEvents.length > 0

            // now let's see if we are over the limit for this category
            var limits = tData.limits.find(x=>x.topic === 'maxRegistration' && x.category === tEvent.category);
            if (limits) { // we have a limit for this category
                const catEvents = tData.events.filter(x=>x.category === tEvent.category).map(x=>x._id);
                const regCatEventCount = tUser.events.filter(x=>x.isRegistered && catEvents.includes(x.eventId)).length;
                maxRegistered = (regCatEventCount > limits.value)
            }

            // now let's see if we are over the limit for all categories
            limits = tData.limits.find(x=>x.topic === 'maxRegistration' && x.category === 'all');
            if (limits) { // we have a limit for all
                const regCatEventCount = tUser.events.filter(x=>x.isRegistered).length;
                allMaxRegistered = (regCatEventCount > limits.value)
            }

            // now let's see if we are over the limit for this event
            tEventMax = tEvent.competitorCount >= tEvent.max;


        }

        return (
            <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2={`Event Registration - ${user.displayname}`} title3={this.feeTitle(finances.owes)}
                bcTitle="Event Registration" bcParents={[{name: tData.title, url: `/pages/tournament/${tData._id}`}]} 
            >
                {tUser.isProfileComplete 
                ?
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-6">
                            <br/>
                            {tData.events.filter(x=>x.status === 'open').map((event, index) => 
                                <div className="row" key={index}>
                                    <div key={index} className="col-12">
                                        <span key={index} onClick={() => this.onItemRegistration(event)} style={{cursor: 'pointer'}}>
                                            <EventRegistrationCube key={index} tournament={tData} tEvent={event} user={user} tUser={tUser} />
                                        </span>
                                    </div>
                                </div>
                            )}                                            
                        </div>
                        <div className="col-sm-6">                         
                        {(finances.owes > 0)
                        ?   <div className="checkout-details">
                                { transaction &&
                                   <div>
                                        <div className="success-text">
                                            <i className="fa fa-check-circle" aria-hidden="true"></i>
                                            <h2>thank you</h2>
                                            <p>Payment has been received.</p>                                                                                                                        
                                        </div>
                                    </div>
                                } 

                                {!transaction && clientToken &&
                                    <div>
                                        <div>
                                            <div className="success-text">
                                                <i className="fa fa-check-circle" aria-hidden="true"></i>
                                                <h2>Please Pay here</h2>
                                            </div>
                                        </div>                                    
                                        <p><strong>NOTE:</strong> Before paying, please make sure your partner, if required, and your designated judge are also committed to this tournament. Once you pay for your event, <u>you will not be able to obtain a refund.</u></p> 
                                        <p>The exception to this policy will be if the entire event is cancelled from the tournament due to an insufficent number of competitors.</p> 

                                        <DropIn
                                            options={{ authorization: clientToken }}
                                            onInstance={instance => (this.btInstance = instance)}
                                        />
                                        <button onClick={this.buy} className="btn btn-success btn-block">Buy</button>
                                        <br/>
                                                                    
                                    </div>
                                } 

                            </div>
                        :   <div className="checkout-details">
                            {(finances.paid > 0)
                            ?   <>
                                <div className="success-text">
                                    <i className="fa fa-check-circle" aria-hidden="true"></i>
                                    <h2>thank you for registering</h2>
                                    <p>Payment has been received.</p>                                                                                                                        
                                    <br/>
                                    <p>Your registration status will remain "Waiting" until your designated judges have made themselves available for at least {tData.judgeRoundMin} rounds. </p>                                                                                                                        
                                    <p>Your registration status will also remain "Waiting" if you registered for a partnered event and have yet to designate your partner (and vice versa).</p> 
                                </div>  
                                </>                              
                            :   <>
                                <div className="success-text">
                                    <i className="fa fa-check-circle" aria-hidden="true"></i>
                                    <h3>Pay here, after registering</h3>
                                    <p>Payment options will appear once you have registered for an event.</p>                                                                                                                        
                                    <p>Click on the card (to the left or above) to register for an event.</p>                                                                                                                        
                                    <br/>
                                </div>  
                                </> 
                            }
                            </div>
                        }
                        </div>
                    </div>  
                </div>
                :   
                <PageCloser 
                    header="Please Register First"
                    message="You need to register with the tournament and complete your profile before you can register for events."
                />
                }  


                <Modal open={open} onClose={this.onCancelEventRegistrationModal} >
                    <div className="modal-header">
                        <h5 className="modal-title f-w-600" id="exampleModalLabel2">
                        {`Register for ${openEventTitle}`}<br/>
                        <small> {this.state.tEvent.resolution}</small>
                        </h5>
                    </div>
                    <div className="modal-body">
                        <div className="container">
                            <div className="card">
                                <div className="card-body" style={{paddingTop: "0px", paddingBottom: "0px"}}>
                                {simRegistered &&
                                <>We're sorry.  You have already registered for an event that takes place simultaneously to this event.  You will not be able to register for both events. </>
                                }
                                {maxRegistered &&
                                <>We're sorry.  You have already registered for the maximum allowed number of events in this category. You will not be able to register for more events of the same category. </>
                                }                                
                                {allMaxRegistered &&
                                <>We're sorry.  You have already registered for the maximum allowed number of events. You will not be able to register for more events. </>
                                }
                                {tEventMax &&
                                <>We're sorry.  This event is full.  </>
                                }
                                {!simRegistered && !maxRegistered && !allMaxRegistered && !tEventMax &&
                                <>                                    
                                    Please check the box to indicate that you wish to register for this event. Please ensure you want to register, because once you check this box, and pay for the event, <strong>you cannot un-register.</strong> <br /> <br />  
                                    <InputCheckbox id="isRegistered" 
                                        disabled={tUserEvent.isPaid} type='checkbox' checked={tUserEvent.isRegistered} 
                                        onChange={this.onEventCompetitorDataChange} 
                                        sublabel={`Registration Status: ${createRegistrationStatus(tUserEvent)}`} placeholder="" 
                                    />
                                    <hr/>
                                    
                                    <h4>Event Registration Questions:</h4> <br />  
                                    <InputRow type="radio" name="experience" title="Experience in this event (years)" value={tUserEvent.experience} options={[
                                        ['u01', 'None'],
                                        ['r01', '1-2'],                        
                                        ['r03', '3-4'],
                                        ['o04', '5 and above'],
                                    ]} 
                                    onChange={this.onEventCompetitorDataChange}
                                    />
                                    {tEvent.teamSize > 1  &&                                
                                        <InputItem label="Partner's Email Address" id="partnerEmail" value={tUserEvent.partnerEmail} onChange={this.onEventCompetitorDataChange} placeholder="" />
                                    }

                                    <hr/>
                                        Each competitor must supply at least one judge for the tournament.  
                                        The judge must be able to judge at least {tData.judgeRoundMin} rounds.  Please make sure you have communicated with the judge before 
                                        you register for this tournament.  Your registration status will remain - pending - until the listed judges have made themselves available for at least {tData.judgeRoundMin} rounds.                                      
                                </>
                                }
                                </div>

                            </div>        
                        </div>
                    </div>
                    <div className="modal-footer">              
                        <button type="button" className="btn btn-primary" onClick={this.onCancelEventRegistrationModal}>Cancel</button>
                        <button id="approveButton" type="button" className="btn btn-primary" onClick={this.onCloseEventRegistrationModal} disabled={simRegistered || maxRegistered || allMaxRegistered || !this.getApprovable(this.state)} >Approve</button>
                    </div>
                </Modal>

                <ModalWindow title="Need Information ..." open={this.state.openProfileNotice} onCancel={this.onProfileNoticeCancel}
                    content={this.notice()}
                    commands={[
                    ]}
                />
            </TournamentPageTemplate>

        )
    }
}

export default EventRegistration;